import * as $http from 'axios'

export default {
    createNPS: (payloads) => $http.post('v2/net_promoter_scores', payloads),
    updateNPS: (id, payloads) => $http.put(`v2/net_promoter_scores/${id}`, payloads),
}
